import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { SETTINGS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WebUrlListPage } from '@/features/webUrls/pages/WebUrlListPage';
import { webUrlSearchSchema } from '@/features/webUrls/types/webUrl.types';

export const Route = createFileRoute('/_auth/settings/web-urls')({
  beforeLoad: () => requirePermission(SETTINGS_PERMISSIONS.WEB_URLS_EDIT),
  validateSearch: webUrlSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Web URLs">
      <Suspense fallback={<PageLoader />}>
        <WebUrlListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
